import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

type FieldProps = {
  id: string;
  label?: string;
  error?: string;
  hint?: string;
  className?: string;
  srOnlyLabel?: boolean;
  children: ReactNode;
};

export function Field({ id, label, error, hint, className, srOnlyLabel, children }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label ? (
        <label
          htmlFor={id}
          className={cn('text-fg-2 text-sm font-medium', srOnlyLabel && 'sr-only')}
        >
          {label}
        </label>
      ) : null}
      {children}
      {error ? (
        <p className="text-danger-700 text-xs">{error}</p>
      ) : hint ? (
        <p className="text-fg-4 text-xs">{hint}</p>
      ) : null}
    </div>
  );
}
